import { render, staticRenderFns } from "./CodeChair.vue?vue&type=template&id=43566a7c&scoped=true&"
import script from "./CodeChair.vue?vue&type=script&lang=js&"
export * from "./CodeChair.vue?vue&type=script&lang=js&"
import style0 from "./CodeChair.vue?vue&type=style&index=0&id=43566a7c&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "43566a7c",
  null
  
)

export default component.exports